// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"creditcard"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 10V20H2L2 10L22 10Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M22 4H2V10H22V4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 4L2 4M22 4V20H2L2 4M22 4V10H2L2 4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 15L6 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CreditcardIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'creditcard',
    ref,
    icon: element,
  },
));

CreditcardIcon.displayName = 'CreditcardIcon';

export default CreditcardIcon;
